/* unplugin-vue-components disabled */import script from "./Input.vue?vue&type=script&setup=true&lang=js"
export * from "./Input.vue?vue&type=script&setup=true&lang=js"

import "./Input.vue?vue&type=style&index=0&id=4ef264d2&lang=scss"

const __exports__ = script;

export default __exports__